import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, withState, getContext, withProps } from 'recompose'

import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as PlaybookActions from 'app/modules/playbook/actions'

import SendButton from './component'

const mapStateToProps = state => ({
  userListIds: PlaybookSelectors.userListIds(state),
  draftId: PlaybookSelectors.draftId(state),
  isSaved: PlaybookSelectors.isSaved(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      schedulePlaybookDraft: PlaybookActions.schedulePlaybookDraft,
    },
    dispatch
  ),
})

export default compose(
  withState('scheduleEmailButtonActive', 'setScheduleEmailButtonActive', true),
  withState('emailButtonLabel', 'setEmailButtonLabel', 'Schedule Email'),
  connect(mapStateToProps, mapDispatchToProps),
  withProps(props => ({
    hasSegmentsSelected: !!props.userListIds && props.userListIds.size,
  })),
  getContext({
    router: PropTypes.object.isRequired,
  }),
  withHandlers({
    handleScheduleClick: props => () => {
      if (!props.onClickConfirm || props.onClickConfirm()) {
        props.setScheduleEmailButtonActive(false)
        props.setEmailButtonLabel('Scheduling...')
        props.actions.schedulePlaybookDraft()
      }
    },
  })
)(SendButton)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/ScheduleButton/index.js